"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferExtraProperties = void 0;
const ctx_1 = require("../ctx");
const evaluate_1 = require("../evaluate");
const infer_1 = require("../infer");
const Values = __importStar(require("../value"));
function inferExtraProperties(mod, ctx, properties, names) {
    const extraInferred = Object.entries(properties)
        .filter(([name, exp]) => !names.includes(name))
        .map(([name, exp]) => [name, (0, infer_1.infer)(mod, ctx, exp)]);
    const extraProperties = Object.fromEntries(extraInferred.map(([name, inferred]) => [name, inferred.core]));
    const extraTypedValues = Object.fromEntries(extraInferred.map(([name, inferred]) => [
        name,
        {
            type: inferred.type,
            value: (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), inferred.core),
        },
    ]));
    return {
        clazz: Values.clazzFromTypedValues(extraTypedValues),
        properties: extraProperties,
    };
}
exports.inferExtraProperties = inferExtraProperties;
//# sourceMappingURL=inferExtraProperties.js.map